<template>
  <div class="signature-image-display">
    <!-- 閲覧専用: Data URL（飼い主側 getAgreement の Base64）または Imgix URL で表示 -->
    <div v-if="src" class="bg-white mb-2 p-2 border">
      <img class="w-100" :src="displaySrc" alt="署名" />
    </div>
    <div v-else class="text-muted small">
      署名なし
    </div>
  </div>
</template>

<script lang="ts">
import { PropType } from 'vue'

/**
 * SignatureImageDisplay.vue
 *
 * 署名画像を閲覧専用で表示する軽量コンポーネント。
 * signature_pad に依存せず、`<img>` のみで描画する。
 *
 * - `data:image/...;base64,...` はサーバー（getAgreement）が S3 から読み込んだ結果としてそのまま表示可能
 * - `u/...` 形式のパスは医院側ログイン時など Imgix 経由で表示する（FlowPageUserInput の編集モードでは主にパッド側を利用）
 */
export default {
  name: 'SignatureImageDisplay',
  props: {
    src: {
      type: String as PropType<string>,
      default: '',
    },
  },
  computed: {
    displaySrc(): string {
      if (!this.src) {
        return ''
      }
      // Data URL の場合はそのまま利用（未ログインの飼い主側でも表示できる）
      if (this.src.startsWith('data:')) {
        return this.src
      }
      // ファイルパスの場合は Imgix 経由（ログイン済み医院ユーザーなど）
      return $core.$imgix?.buildUrl(this.src) ?? ''
    },
  },
}
</script>

<style scoped>
.signature-image-display img {
  max-height: 200px;
  object-fit: contain;
}
</style>
